<template lang="pug">
Layout(:header-bgc="true")
  template(slot="page")
    .container
      .content
        h2 关于我们
        p
          | CDP 融合了市面上各家 CDN 厂商，致力于打造新一代的智能融合云服务平台，为企业提供更加快速、安全、稳定的域名调度解决方案，
          | 帮助企业统一调配管理各 CDN 厂商的服务，做到让企业更加省心、放心
        h2 我们的优势
        p 融合各热门 CDN 厂商
        p 可按任意比例配置调度各 CDN 厂商间流量的平台
        p 灵活调度，实现域名的所有访问地区都有本地节点覆盖
        p 问题节点智能切换，保证域名正常运行
        p 多维度告警通知，实时掌握网站动态
        h2 联系我们
        p 公司地址：杭州市西湖区文一西路522号9幢1单元602室
        p 邮箱：sales@oncdp.com
</template>

<script>
import Layout from '../components/layout'
import Banner from '../components/banner'
import Features from '../components/features'
import Usage from '../components/usage'
import Functions from '../components/functions'
import WhatIs from '../components/whatis'

export default {
  name: 'contact',
  components: { Layout, Banner, Features, Functions, Usage, WhatIs }
}

</script>

<style lang="sass" scoped>
.container
  width: 1170px
  min-height: 100%
  margin: 0 auto
  color: #ffffff

.content
  padding: 20px 130px 100px

h2
  font-size: 18px
  color: #333333
  margin-top: 50px
  margin-bottom: 34px

p
  font-size: 14px
  color: #666666
  line-height: 1.8

</style>



// WEBPACK FOOTER //
// contact.vue?4afb1433